<template>
    <base-dblclick-input
      class="inline"
      model-type="contactClientRelationship"
      :model-id="clientContact.id"
      field-name="title"
      :field-value="clientContact.title"
      input-type="text"
      @refetch="fetchNewClients"
    ></base-dblclick-input>
  </template>
  
  <script setup>
  import {defineProps, defineEmits} from "vue";
  
    const props = defineProps(['clientContact'])
  
    const emit = defineEmits(['refetch-clients'])
  
    function fetchNewClients () {
        emit('refetch-clients')
    }
  
  </script>